<template>
<v-layout>
  <v-flex xs8>
    <v-text-field type="text" :label="`${index +1}) ${label}`" :value="data.name" :rules="nameRules" @change="update({name: $event})" />
  </v-flex>
  <v-flex xs1>
    <description :fieldName="data.name" :description="data.description" :small="true" @update="updateDescription($event)" @updateImages="updateOptions"></description>
  </v-flex>
  <v-flex xs1>
    <v-dialog width="500" v-model="optionsDialog">
      <v-btn fab small dark color="indigo" slot="activator">
        <v-icon>settings</v-icon>
      </v-btn>
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ label }}
        </v-card-title>
        <v-divider />
        <component :is="this.data.type + '-options'" :context="context" :id="this.data.id" :key="data.id + '-sub-options'" :options="data.options || {}" @update="this.updateOptions"></component>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="optionsDialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
  <v-flex xs1>
    <v-btn fab small dark color="warning" @click="destroy">
      <v-icon>delete_forever</v-icon>
    </v-btn>
  </v-flex>
</v-layout>
</template>

<script>
import TextOptions from './options/TextOptions'
import NumberOptions from './options/NumberOptions'
import DateOptions from './options/DateOptions'
import TimeOptions from './options/TimeOptions'
import SignatureOptions from './options/SignatureOptions'
import PhotoOptions from './options/PhotoOptions'
import CodeOptions from './options/CodeOptions'
import MultipleOptions from './options/MultipleOptions'
import RelatedOptions from './options/RelatedOptions'
import SelectDependOptions from './options/SelectDependOptions'
import StorageOptions from './options/StorageOptions'
import subField from '@/mixins/subField'
import Description from './Description'
import field from '@/mixins/field'
export default {
  name: "sub-field",
  components: {
    Description,
    "number-options": NumberOptions,
    "text-options": TextOptions,
    "date-options": DateOptions,
    "time-options": TimeOptions,
    "multiple-options": MultipleOptions,
    "signature-options": SignatureOptions,
    "photo-options": PhotoOptions,
    "code-options": CodeOptions,
    "related-options": RelatedOptions,
    "depend-options": SelectDependOptions,
    "storage-options": StorageOptions
  },
  mixins: [subField, field],
  props: ["data", "index"],
  data() {
    return {
      optionsDialog: false,
    }
  },
  computed: {
    label() {
      switch (this.data.type) {
      case 'text':
        return this.$t('schema.builder.inputs.text-field')
      case 'number':
        return this.$t('schema.builder.inputs.number-field')
      case 'date':
        return this.$t('schema.builder.inputs.date-field')
      case 'time':
        return this.$t('schema.builder.inputs.time-field')
      case 'signature':
        return this.$t('schema.builder.inputs.signature-field')
      case 'photo':
        return this.$t('schema.builder.inputs.photo-field')
      case 'code':
        return this.$t('schema.builder.inputs.code-field')
      case 'multiple':
        return this.$t('schema.builder.inputs.multiple-field')
      case 'related':
        return this.$t('schema.builder.inputs.related-field')
      case 'depend':
        return this.$t('schema.builder.inputs.select-depend-field')
      case 'storage':
        return this.$t('schema.builder.inputs.storage-field')
      }
    }
  },
  methods: {
    updateDescription(description) {
      let payload = {
        id: this.data.id,
        description
      }
      this.$store.commit("updateSubFieldDescription", payload)
    }
  }
}
</script>
